!function() {
  var t = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : "undefined" != typeof window ? window : "undefined" != typeof global ? global : {}, e = {}, a = {}, i = t.parcelRequire5f74;
  null == i && ((i = function(t) {
    if (t in e) return e[t].exports;
    if (t in a) {
      var i = a[t];
      delete a[t];
      var r = {
        id: t,
        exports: {}
      };
      return e[t] = r, i.call(r.exports, r, r.exports), r.exports;
    }
    var n = new Error("Cannot find module '" + t + "'");
    throw n.code = "MODULE_NOT_FOUND", n;
  }).register = function(t, e) {
    a[t] = e;
  }, t.parcelRequire5f74 = i), (0, i.register)("6ph3s", function(t, e) {
    var a, i, r, n;
    a = t.exports, i = "default", r = function() {
      return o;
    }, Object.defineProperty(a, i, {
      get: r,
      set: n,
      enumerable: !0,
      configurable: !0
    });
    var o = (t, e) => {
      const a = [ "USD", "CAD", "AUD", "HKD", "SGD", "NZD", "SEK", "DKK", "NOK", "CHF" ].includes(e), i = [ "USD", "CAD", "AUD", "HKD", "SGD", "NZD" ].includes(e);
      if (a) {
        return `${i ? "$" : ""}${Shopify.formatMoney(t, "{{amount_no_decimals}}")} <span class="text-3xs">${e}</span>`;
      }
      return Shopify.formatMoney(t, Shopify.money_format).replace(/\.00$/, "");
    };
  });
  var r = i("6ph3s");
  customElements.get("product-form") || customElements.define("product-form", class extends HTMLElement {
    form=this.querySelector("form");
    lowInventory=+this.dataset.lowInventory;
    currentVariant=!1;
    options;
    lastGtmEvent={
      handle: null,
      value: null,
      time: 0
    };
    getParent=() => this.closest("[data-product]") || this.closest(".shopify-section");
    getTarget=(t = !1) => [ this, "" ];
    buttons=() => {
      const [t, e] = this.getTarget();
      return Array.from(t.querySelectorAll(`${e}[type="submit"]`)).filter(t => !t.closest("stock-notifier"));
    };
    onChange=t => {
      t.target.hasAttribute("data-ignore") || (this.pushOptionChangeToGTM(t), this.updateOptions(t), 
      this.updateMasterId(t), this.updatePrice(), this.updateInventory(), this.updateURL(), 
      this.updateMadeToOrder(), this.updateStockNotifier(), this.updateButton(this.currentVariant ? this.currentVariant.available ? "available" : "soldOut" : "unavailable"), 
      this.dispatchEvent(new CustomEvent("variant:change", {
        bubbles: !0,
        detail: {
          variant: this.currentVariant
        }
      })));
    };
    pushOptionChangeToGTM=t => {
      if (!t.isTrusted) return;
      const e = t.target, a = e.getAttribute("data-gtm-option-name");
      if (!a) return;
      const i = a.toLowerCase().trim().replace(/[\s-]+/g, "_"), r = e.value, n = Date.now();
      if (this.lastGtmEvent.handle === i && this.lastGtmEvent.value === r && n - this.lastGtmEvent.time < 100) return;
      this.lastGtmEvent = {
        handle: i,
        value: r,
        time: n
      };
      const o = this.getProductData();
      window.dataLayer = window.dataLayer || [];
      const s = {
        event: `${i}_select`,
        content_type: `pdp_${i}`,
        item_id: this.currentVariant?.sku || o.id,
        item_name: o.title,
        product_name: o.title,
        page_section: "main-content",
        page_type: "pdp"
      };
      s[`${i}_selected`] = r, window.dataLayer.push(s);
    };
    updateStockNotifier=() => {
      if (!this.stockNotifierEl) return;
      const t = !this.currentVariant || this.currentVariant.available;
      this.stockNotifierEl.classList.toggle("hidden", t), this.stockNotifierEl.setAttribute("aria-hidden", t);
    };
    updateOptions=t => {
      const [e, a] = this.getTarget(t), {target: i} = t;
      e.querySelectorAll(`${a}[data-option-title="${i.name}"]`).forEach(t => t.textContent = i.value), 
      e.querySelectorAll(`${a}[name="${i.name}"]`).forEach(t => {
        "SELECT" === t.tagName ? t.value = i.value : t.checked = t.value == i.value;
      }), this.options = Array.from(this.querySelectorAll('select[name^="option"],input[name^="option"]:checked'), t => t.value);
    };
    updateMasterId=t => {
      const e = this.getVariantData();
      this.currentVariant = 1 === e.length ? e[0] : e.find(t => !t.options.some((t, e) => this.options[e] !== t)), 
      this.querySelector('[name="id"]').value = this.currentVariant?.id || "";
      const [a, i] = this.getTarget(t);
      a.querySelectorAll(`${i}[data-variant-title]`).forEach(t => t.dataset.variantTitle = this.currentVariant?.title || ""), 
      a.querySelectorAll(`${i}[data-variant-sku]`).forEach(t => t.dataset.variantSku = this.currentVariant?.sku || "");
    };
    updateInventory=() => {
      const t = this.querySelector("[data-inventory]"), e = this.currentVariant;
      t.innerText = this.lowInventory && e && e.inventory_quantity > 0 && e.inventory_quantity <= this.lowInventory && "shopify" === e.inventory_management && "deny" === e.inventory_policy ? window.strings?.inventory?.only?.replace("{{ count }}", e.inventory_quantity) : "";
    };
    updatePrice=() => {
      const t = this.getProductData(), e = this.currentVariant?.price || t.price, a = this.currentVariant?.compare_at_price || t.compare_at_price, i = a > e;
      this.getParent().querySelectorAll("[data-price]").forEach(t => {
        t.innerHTML = (0, r.default)(e, window.Shopify.currency.active);
        const a = !t.parentElement.hasAttribute("data-is-atc");
        t.classList.toggle("text-red", i && a), a || (t.parentElement.classList.toggle("hidden", !this.currentVariant?.available), 
        t.parentElement.classList.toggle("flex", this.currentVariant?.available));
      }), this.getParent().querySelectorAll("[data-compare-at-price]").forEach(t => {
        t.innerHTML = i && !t.parentElement.hasAttribute("data-is-atc") ? (0, r.default)(a, window.Shopify.currency.active) : "";
      });
    };
    updateButton=t => {
      const e = {
        available: {
          text: window.strings.addToCart,
          disabled: !1
        },
        soldOut: {
          text: window.strings.soldOut,
          disabled: !0
        },
        unavailable: {
          text: window.strings.selectOptions,
          disabled: !0
        }
      }, {text: a, disabled: i} = e[t];
      this.buttons().forEach(t => {
        const e = t.querySelector("[data-atc-text]"), r = t.querySelector("[data-atc-price]");
        (e || t).textContent = a, r && (r.classList.toggle("flex", !i), r.classList.toggle("hidden", i)), 
        t.closest("[data-sticky]") || (t.disabled = i, t.classList.toggle("btn--primary", !i), 
        t.classList.toggle("btn--secondary", i));
      });
    };
    updateURL=() => {
      if (!this.hasAttribute("data-url")) return;
      if (this.getVariantData().length <= 1 || !this.currentVariant || this.hasAttribute("data-modal") || !this.querySelector('[type="submit"]')) return;
      const t = new URL(window.location.href);
      t.searchParams.set("variant", this.currentVariant.id);
      const e = `${this.dataset.url}${t.searchParams.toString() ? `?${t.searchParams}` : ""}`;
      window.history.replaceState({
        path: e
      }, "", e);
    };
    updateMadeToOrder=() => {
      const t = this.querySelector("[data-made-order]");
      if (!t || "true" !== t.dataset.madeOrder) return;
      const e = this.currentVariant;
      t.innerHTML = e && "shopify" === e.inventory_management && "continue" === e.inventory_policy && e.inventory_quantity <= 0 ? `<input type="hidden" name="properties[Made to order]" value="${window.strings.madeToOrderProperty}">` : "";
    };
    getProductData=() => {
      if (!this.productData) {
        const t = '[type="application/json"][data-product-json]', e = this.querySelector(t) || this.querySelector('[type="application/json"]');
        this.productData = JSON.parse(e.textContent);
      }
      return this.productData;
    };
    getVariantData=() => {
      if (!this.variantData) {
        const t = '[type="application/json"][data-variant-json]', e = this.querySelector(t);
        this.variantData = e ? JSON.parse(e.textContent) : this.getProductData().variants;
      }
      return this.variantData;
    };
    onSubmitHandler=async t => {
      t.preventDefault();
      const e = document.querySelector('input[type="checkbox"][id^="Modal-"][data-locker]:checked');
      e && e.checked && e.click();
      try {
        await window.Shopify.addToCart(this.form);
      } catch (t) {
        console.error("Product form submit add to cart failed:", t), this.form.submit();
      }
    };
    initializeVariant=() => {
      this.options = Array.from(this.querySelectorAll('select[name^="option"],input[name^="option"]:checked'), t => t.value);
      const t = this.getVariantData();
      this.currentVariant = 1 === t.length ? t[0] : t.find(t => !t.options.some((t, e) => this.options[e] !== t)), 
      this.querySelector('[name="id"]').value = this.currentVariant?.id || "", this.updatePrice(), 
      this.updateInventory(), this.updateMadeToOrder(), this.updateStockNotifier(), this.updateButton(this.currentVariant ? this.currentVariant.available ? "available" : "soldOut" : "unavailable"), 
      this.dispatchEvent(new CustomEvent("variant:change", {
        bubbles: !0,
        detail: {
          variant: this.currentVariant
        }
      }));
    };
    connectedCallback() {
      const t = this.form.getAttribute("id");
      t ? document.querySelectorAll(`[form="${t}"]`).forEach(t => t.addEventListener("change", this.onChange)) : this.addEventListener("change", this.onChange), 
      this.stockNotifierEl = this.querySelector("stock-notifier"), this.form.addEventListener("submit", this.onSubmitHandler), 
      this.initializeVariant(), this.querySelectorAll("[data-quantity]").forEach(t => {
        t.addEventListener("click", e => {
          e.preventDefault(), e.stopPropagation();
          const a = t.parentNode.querySelector('[name="quantity"]'), i = Math.max(1, +a.value + (t.hasAttribute("data-minus") ? -1 : 1));
          this.getParent().querySelectorAll('[name="quantity"]').forEach(t => t.value = i);
        }), t.classList.remove("hidden");
      });
    }
  });
}();